














    import { Vue, Component, Prop,Watch } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import { StoreState } from '../../../store';   
import { warn } from 'vue-class-component/lib/util';

    @Component({
        computed: {
            ...mapState({
                'enabled': (state: StoreState) => state.reports.scheduleForm.enabledDay,
                'weeklyEnabled': (state: StoreState) => state.reports.scheduleForm.weeklyEnabled,
                'WeeklyDays_Enalbelist': (state: StoreState) =>  state.reports.scheduleForm.WeeklyDays_EnalbeList,
                
            }),
            dowSingle: function() {
                return (this as any).dayOfWeek[0].toUpperCase();
            },
            todayEnabled: function() {
                return (this as any).dayOfWeek === (this as any).enabled;
            }
        },
    })
    export default class DayOfWeek extends Vue {
        @Prop() dayOfWeek!: string;
        enabled!: boolean;
        weeklyEnabled!: boolean;

          data() {  
            return {
                checked:false,
            }
        }



 
        dayClicked() {
            this.$store.commit('SET_SCHEDULE_DAY', this.dayOfWeek);
            this.$emit('resetError');
        }

        check(e) {
        if (e.target.checked) {
            console.log(e.target.value)
        }
        }

        Spell_single(day){
            return day.charAt(0).toUpperCase();
        } 

    

    }
